"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxelarRouteAction = exports.SquidTransactionStatus = void 0;
var SquidTransactionStatus;
(function (SquidTransactionStatus) {
    SquidTransactionStatus["SUCCESS"] = "success";
    SquidTransactionStatus["NEEDS_GAS"] = "needs_gas";
    SquidTransactionStatus["ONGOING"] = "ongoing";
    SquidTransactionStatus["PARTIAL_SUCCESS"] = "partial_success";
    SquidTransactionStatus["NOT_FOUND"] = "not_found";
    SquidTransactionStatus["FAILED_DESTINATION"] = "failed_on_destination";
})(SquidTransactionStatus = exports.SquidTransactionStatus || (exports.SquidTransactionStatus = {}));
var AxelarRouteAction;
(function (AxelarRouteAction) {
    AxelarRouteAction["CALL"] = "call";
    AxelarRouteAction["EXECUTED"] = "executed";
    AxelarRouteAction["IBC_TRANSFER"] = "ibc_transfer";
    AxelarRouteAction["SEND"] = "send";
    AxelarRouteAction["VOTE"] = "vote";
    AxelarRouteAction["IBC_SEND"] = "ibc_send";
    AxelarRouteAction["GAS_PAID"] = "gas_paid";
    AxelarRouteAction["APPROVED"] = "approved";
})(AxelarRouteAction = exports.AxelarRouteAction || (exports.AxelarRouteAction = {}));
//# sourceMappingURL=index.js.map